import { AbsoluteCenter, useDisclosure } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import AlertInvalidBet from "./AlertInvalidBet";
import { useEffect } from "react";

const AlertInvalidBetButton = () => {
  const gameConfig = useSelector((state) => state.isGameConfig);

  const { is_invalid_bet } = gameConfig;

  const { onOpen, isOpen } = useDisclosure();

  useEffect(() => {
    if (is_invalid_bet === 1) {
      onOpen();
    }
  }, [is_invalid_bet, onOpen]);

  if (is_invalid_bet === 0) {
    return null;
  }

  return <AbsoluteCenter>{isOpen ? <AlertInvalidBet /> : null}</AbsoluteCenter>;
};

export default AlertInvalidBetButton;
